export const Wordmark = ({ size = 22, color = "#2b2b2b", className = "", testId = "cuvano-wordmark" }) => (
  <span className={`wordmark ${className}`} style={{ fontSize: size, color }} data-testid={testId} aria-label="Cuvano">CUVANO</span>
);

export const BrandBlock = ({ size = 22, center = false, testId = "brand" }) => (
  <div className="brand-block" style={{ alignItems: center ? "center" : "flex-start", textAlign: center ? "center" : "left" }} data-testid={testId}>
    <Wordmark size={size} />
    <span className="brand-product">CountHub</span>
  </div>
);

export const Footer = () => (
  <footer className="footer" data-testid="footer">
    Powered by <Wordmark size={11} color="#6e6e73" className="footer-mark" testId="footer-wordmark" />
  </footer>
);
